import React from 'react';
import {
  Component,
  Position
} from 'puzzle'
import { Popup } from "@progress/kendo-react-popup";
import { GROUPED_TASK, OFFSET, SUBMISSION } from '../Types';
import * as _ from "lodash";
import { Keys } from '@progress/kendo-react-common';
import {
  disableActions,
  getUrlWithParams,
  hiddenActionPairsMap,
  prepareMassActions,
  SUBMISSION_STATUSES_MAP_SERVER_CORE_UI,
  taskSorter
} from '../../../util/Util';
import ActionExecutorInstance from "../../../SupplierView/TaskList/ActionExecutor/ActionExecutor";
import { ACTION } from "../../../SubmissionsList/ActionToolbar/ActionToolbar";
import classNames from 'classnames';
import { TASK } from "../../../SupplierView/TaskGrid/Types";

type PROPS = {
  closeMenuHandler: Function
  offset: OFFSET
  contextMenuItem: SUBMISSION,
  show: boolean,
  selectionLimit: number
};

type STATE = {
  actions: ACTION[]
  availableActions: string[]
  checkboxSelected: any[]
}

class ContextMenu extends Component<PROPS, STATE> {
  protected menuRef: any = null;
  protected popupElement: any = null;
  columnPopupArrowIndex = 0;

  static defaultProps = {
    closeMenuHandler: () => {
    },
    offset: {
      left: 0,
      top: 0
    },
    show: false
  };

  componentDidUpdate(prevProps: Readonly<any>): void {
    let { show } = this.props;
    if (!_.isEqual(prevProps, this.props)) {
      const { contextMenuItem: submission } = this.props;
      if (submission) {
        if (!submission.availableTasks) {
          submission.availableTasks = 0;
        }
        this.setState({ availableActions: disableActions([submission]) });
        if (show) {
          setTimeout(() => this.focusMenuOnOpen(), 0);
          document.addEventListener('click', this.handleOutsideClick);
        } else {
          document.removeEventListener('click', this.handleOutsideClick);
        }
      }
    }
  }

  /**
   * Opens File Assign Supplier dialog
   * @param task
   */
  assignFilesSupplier = (task: TASK) => {
    let {
      sourceLanguage,
      targetLanguage,
      projectId,
      submissionId,
      taskId,
      fileCount: filesCount
    } = task;

    this.dispatch('assignCrossoverDialog', '', {
      dialogData: {
        assignRequestParams: {
          submissionId,
          taskId
        },
        filesCount,
        projectId,
        sourceLanguage,
        submissionId,
        targetLanguage,
        taskId
      }
    });
  }

  /**
   * Dispatch action for download
   * @param submission
   * @param params
   */
  dispatchDownloadAction = (submission: any, params: any) => {
    let availableOrReserved = submission.taskStatus?.name === 'AVAILABLE' || submission.taskStatus?.name === 'RESERVED';
    let actionName;
    let confirmActionName;
    if (availableOrReserved && (params.downloadType !== 'references')) {
      actionName = 'previewWarningAndDownload';
      confirmActionName = 'downloadFiles';
    } else {
      actionName = 'downloadFiles';
    }
    this.dispatch(actionName, '', {
      submissionData: submission,
      params: params,
      confirmActionName
    });
  }

  /**
   * Focuses first available action
   */
  focusMenuOnOpen = () => {
    this.columnPopupArrowIndex = 0;
    const domNode = this.menuRef;
    if (domNode) {
      const selector = domNode?.querySelectorAll('li.tp-available-actions');
      if (selector?.length) {
        selector[0].focus();
      } else {
        domNode.addEventListener('keydown', this.onTopElKeyDown);
        domNode.focus();
      }
    }
  };

  /**
   * Updates action array with new actions, preserving existing one
   *
   * @param newActions
   */
  modifyActionTasksWithNewActions = (newActions: ACTION[]) => {
    const { actions = [] } = this.state;
    newActions = _.unionBy(actions, newActions, 'taskName');
    return newActions;
  };

  /**
   * Prepare data and set to state
   */
  setData = (data: ACTION[]) => {
    data = this.modifyActionTasksWithNewActions([...data]);
    data = prepareMassActions(data);

    this.setState({
      actions: data
    });
  };

  /**
   * Creates items for DropDown menu
   * @param {ACTION[]} actions
   * @param {string[]} availableActions
   */
  createMenuItems = (actions: ACTION[], availableActions: string[]) => {
    availableActions.push('copy URI');
    let { checkboxSelected } = this.state;
    const { contextMenuItem, selectionLimit } = this.props;
    let i = 0;
    let menu: any = [];
    let taskName: string;
    let massTaskName: string;
    let group: any;
    const groupedActions: GROUPED_TASK[] = taskSorter(actions);
    for (group of groupedActions) {
      const {
        groupName,
        elements = []
      } = group;
      i = 0;
      if (groupName !== 'hidden') {
        while (i < elements.length) {
          let current = elements[i];
          taskName = current.taskName;
          massTaskName = current.massTaskName;
          let taskLocalized = this.translate(_.replace(taskName, / /g, '_'));
          let isDisabled = availableActions && !availableActions.includes(taskName);
          if (checkboxSelected && checkboxSelected.length > 1) {
            const isSubmissionSelected = contextMenuItem.taskId ? _.find(checkboxSelected, { taskId: contextMenuItem.taskId }) : _.find(checkboxSelected, { submissionId: contextMenuItem.submissionId });
            const massSelectionActive = contextMenuItem && isSubmissionSelected;
            if (massSelectionActive) {
              isDisabled = !massTaskName || checkboxSelected.length > selectionLimit;
              if (massTaskName) {
                taskLocalized = `${taskLocalized} (${checkboxSelected.length})`;
              }
            }
          }

          let hiddenAction = hiddenActionPairsMap.get(taskName);
          if (!(hiddenAction && isDisabled && availableActions.includes(hiddenAction))) {
            let className = classNames('k-list-item', {
              'tp-available-actions': !isDisabled,
              'k-disabled': isDisabled
            });
            menu.push(
              <li
                tabIndex={0}
                aria-disabled={isDisabled}
                className={className}
                key={taskName}
                role="menuitem"
                onKeyDown={this.onKeyDown.bind(this, taskName, massTaskName)}
              >
            <span
              className={'tp-100 k-white-space-nowrap k-d-flex'}
              role="button"
              onClick={this.menuItemClickHandler.bind(this, taskName, massTaskName)}
            >
            {taskLocalized}
            </span>
              </li>
            );
          }
          i++;
        }
        menu.push(<div className={'k-separator'} key={'separator-' + groupName} />)
      }
    }
    return menu;
  };

  /**
   * Handles Enter (execute action) and Esc (close popup)
   *
   * @param {string} taskName
   * @param {string} massTaskName
   * @param {any} e
   */
  onKeyDown = (taskName: string, massTaskName: string, e: any) => {
    const elementNodeList = this.menuRef?.querySelectorAll('li.tp-available-actions');
    switch (e.keyCode) {
      case Keys.enter:
        if (e.currentTarget.className?.search('k-disabled') === -1) {
          this.menuItemClickHandler(taskName, massTaskName);
        }
        break;
      case Keys.esc:
        this.props.closeMenuHandler();
        break;
      case Keys.down:
        if (this.columnPopupArrowIndex >= elementNodeList.length - 1) {
          this.columnPopupArrowIndex = -1
        }
        elementNodeList[++this.columnPopupArrowIndex].focus();
        break;
      case Keys.up:
        if (this.columnPopupArrowIndex === 0) {
          this.columnPopupArrowIndex = elementNodeList.length;
        }
        elementNodeList[--this.columnPopupArrowIndex].focus();
        break;
      default:
        break;
    }
  };

  /**
   * To support close on esc if there are no available actions
   *
   * @param e
   */
  onTopElKeyDown = (e: any) => {
    if (Keys.esc === e.keyCode) {
      this.props.closeMenuHandler();
    }
  };

  /**
   * Closes the menu before task schedule
   * @param {string} taskName Name of the task and also name of the Action in Dispatcher
   * @param {string} massTaskName Task name for mass action
   */

  menuItemClickHandler = (taskName: string, massTaskName: string) => {
    this.props.closeMenuHandler();
    const { contextMenuItem: submission, selectionLimit } = this.props;
    let editor;
    let { checkboxSelected } = this.state;
    let taskNameForSwitch: string = taskName

    const isSubmissionSelected = submission.taskId ? _.find(checkboxSelected, { taskId: submission.taskId }) : _.find(checkboxSelected, { submissionId: submission.submissionId });
    const massSelectionActive = submission && isSubmissionSelected;
    if (checkboxSelected?.length > 1 && massSelectionActive) {
      taskNameForSwitch = massTaskName;
    } else {
      this.dispatch('checkboxSelectionClear');
    }
    switch (taskNameForSwitch) {
      case 'analyze submission':
      case "assign submission vendor":
      case "claim":
      case 'claim job phase':
      case 'delete submission system':
      case "manual edit submission":
      case 'manual clone submission':
      case 'quote request':
      case 'quote withdraw':
      case 'start submission':
      case 'quote review report':
      case 'quote review':
      case 'quote add edit po':
      case 'rest upload':
      case 'unclaim job phase':
      case 'job phase upload':
      case 'reserve job phase':
      case 'reopen submission':
      case 'job phase view offer':
        taskName && this.dispatch(_.replace(taskName, / /g, '_'), '', { submissionData: submission });
        break;
      case "manual edit completed submission":
        taskName && this.dispatch('manual_edit_submission', '', { submissionData: submission });
        break;
      case 'manual submission':
        this.dispatch('goToPath', '', { path: '/view/submission' });
        break;
      case 'preview translation':
        const submissionIds = submission.submissionId;
        const submissionName = submission.submissionName;
        this.dispatch('preview_translation', '', { params: { submissionIds }, submissionName });
        break;
      case 'download submission source files':
        this.dispatch('source_files', '', {
          submissionId: submission.submissionId,
          submissionName: submission.submissionName
        });
        break;
      case 'download submission history':
        this.dispatch('downloadAuditLog', '', {
          submissionId: submission.submissionId,
          params: {
            submissionHistory: true
          }
        });
        break;
      case 'cancel nui':
        if (SUBMISSION_STATUSES_MAP_SERVER_CORE_UI.ON_HOLD.includes(submission.submissionStatus.name)) {
          this.dispatch('cancelOnHoldSubmission', {
            pos: Position.end,
            persistent: ['submissionId']
          }, { submissionData: submission, submissionId: submission.submissionId });
        } else {
          this.dispatch(_.replace(taskName, / /g, '_'), '', { submissionData: submission });
        }
        break;
      case  'task download reference files':
        let paramsReferenceFiles = { downloadType: 'references' };
        this.dispatchDownloadAction(submission, paramsReferenceFiles);
        break;
      case  'task download source files':
        let paramsSourceFiles = { downloadType: 'sources' };
        this.dispatchDownloadAction(submission, paramsSourceFiles);
        break;
      case  'task download supplementary files':
        let paramsSupplementaryFiles = { downloadType: 'supplementary' };
        this.dispatch('downloadFiles', '', { submissionData: submission, params: paramsSupplementaryFiles });
        break;
      case  'task download glp':
        let paramsGLPFiles = { downloadType: 'WF5' };
        this.dispatchDownloadAction(submission, paramsGLPFiles);
        break;
      case  'task download all kits':
        let paramsLocalizationKit = { downloadType: 'localizationKit' };
        this.dispatchDownloadAction(submission, paramsLocalizationKit);
        break;
      case 'open jobphase editor':
        editor = _.get(submission, 'availableEditors[0]');
        ActionExecutorInstance.executeOpenTask(submission, editor);
        break;
      case 'task complete jobPhase files':
        this.dispatch('completeConfirmationWarning', '', {
          submissionData: submission
        });
        break;
      case 'task return jobPhase files':
        this.dispatch('task_complete_jobPhase_files', '', {
          actionName: 'demote',
          executionModuleName: 'ActionExecutor',
          promoteFilesAction: 'completeActionWarnings',
          submissionData: submission,
          completeSupplierURL: `/jobPhases/${submission.taskId}/return`
        });
        break;
      case 'task preview jobphase':
        ActionExecutorInstance.previewTask(submission);
        break;
      //mass actions
      case 'mass claim job phase':
      case 'mass unclaim job phase':
      case 'mass start submission':
        if (checkboxSelected.length && checkboxSelected.length <= selectionLimit) {
          this.dispatch(_.replace(massTaskName, / /g, '_'), '', { selectedItems: checkboxSelected });
        }
        break;
      case "task assign jobPhase files":
        // @ts-ignore
        this.assignFilesSupplier(submission);
        break;
      case "copy URI":
        // @ts-ignore
        let urlToCopy = getUrlWithParams(submission.submissionId);
        this.dispatch(_.replace(taskName, / /g, '_'), '', { urlToCopy });
        break;
      default:
        break;
    }
  };

  /**
   * Handle documents click. Close menu if click is outside
   */
  handleOutsideClick = (event: MouseEvent) => {
    let { show } = this.props;

    if (show) {
      let element = event.target;
      let menuEl = this.menuRef;
      if (menuEl && !menuEl.contains(element)) {
        this.props.closeMenuHandler();
      }
    }
  };

  /**
   * Set checkbox selected items
   */
  setCheckboxSelected = (items: any[]) => {
    this.setState({
      checkboxSelected: items
    });
  }

  render = () => {
    let { offset, show } = this.props;
    let { actions, availableActions } = this.state;
    let minHeight = _.get(this.popupElement, '_popup.clientHeight'); //https://techqa1.translations.com/browse/PDII-35537

    return (
      <Popup
        ref={node => this.popupElement = node}
        offset={offset}
        show={show}
        {...(minHeight && { style: { minHeight } })}
      >
        <ul ref={node => this.menuRef = node}
            role="presentation"
            aria-label={this.translate('SRL-submissionActionLabel')}
            className={'k-list k-reset tp-action-dropdown-list'}
        >
          {actions && availableActions && this.createMenuItems(actions, availableActions)}
        </ul>
      </Popup>
    );
  }
}

export default ContextMenu;
